module.exports = __webpack_public_path__ + "img/063aa01.jpg";